import { __assign, __awaiter, __generator, __rest } from "tslib";
import * as React from 'react';
export function useAsync(props) {
    var _this = this;
    var onSearch = props.onSearch, _a = props.cacheOptions, cacheOptions = _a === void 0 ? false : _a, _b = props.defaultOptions, propsDefaultOptions = _b === void 0 ? false : _b, propsLoadOptions = props.loadOptions, propsInputValue = props.inputValue, comboboxProps = __rest(props, ["onSearch", "cacheOptions", "defaultOptions", "loadOptions", "inputValue"]);
    var _c = React.useState(propsInputValue), searchString = _c[0], setSearchString = _c[1];
    var _d = React.useState(''), loadedSearchString = _d[0], setLoadedSearchString = _d[1];
    var _e = React.useState(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : null), defaultOptions = _e[0], setDefaultOptions = _e[1];
    var _f = React.useState(), cachedOptions = _f[0], setCachedOptions = _f[1];
    var _g = React.useState(), asyncOptions = _g[0], setAsyncOptions = _g[1];
    var _h = React.useState(propsDefaultOptions === true), isLoading = _h[0], setIsLoading = _h[1];
    var pendingRequest = React.useRef(undefined);
    var prevSearchString = React.useRef(searchString);
    var _j = React.useState(undefined), prevCacheOptions = _j[0], setPrevCacheOptions = _j[1];
    var mounted = React.useRef(false);
    var loadOptions = React.useCallback(function (inputValue, callback) { return __awaiter(_this, void 0, void 0, function () {
        var loader, options_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!propsLoadOptions) {
                        return [2 /*return*/, callback()];
                    }
                    loader = propsLoadOptions(inputValue, callback);
                    if (!(loader && typeof loader.then === 'function')) return [3 /*break*/, 2];
                    return [4 /*yield*/, loader];
                case 1:
                    options_1 = _a.sent();
                    callback(options_1);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [propsLoadOptions]);
    var handleOnSearch = React.useCallback(function (searchValue) {
        if (searchValue === prevSearchString.current) {
            return;
        }
        prevSearchString.current = searchValue;
        if (!searchValue || searchValue === '') {
            setSearchString('');
            setLoadedSearchString('');
            setAsyncOptions([]);
            setIsLoading(false);
            return;
        }
        if (cacheOptions && (cachedOptions === null || cachedOptions === void 0 ? void 0 : cachedOptions[searchValue])) {
            setSearchString(searchValue);
            setLoadedSearchString(searchValue);
            setAsyncOptions(cachedOptions[searchValue]);
            setIsLoading(false);
        }
        else {
            var request_1 = (pendingRequest.current = {});
            setSearchString(searchValue);
            setIsLoading(true);
            loadOptions(searchValue, function (options) {
                var _a;
                if (!mounted.current || request_1 !== pendingRequest.current) {
                    return;
                }
                pendingRequest.current = undefined;
                setLoadedSearchString(searchValue);
                setAsyncOptions(options !== null && options !== void 0 ? options : []);
                setCachedOptions(options ? __assign(__assign({}, cachedOptions), (_a = {}, _a[searchValue] = options, _a)) : cachedOptions);
                setIsLoading(false);
            });
        }
        if (onSearch) {
            onSearch(searchValue);
        }
    }, [onSearch, setAsyncOptions, loadOptions, cacheOptions, cachedOptions]);
    React.useEffect(function () {
        if (cacheOptions !== prevCacheOptions) {
            setPrevCacheOptions(cacheOptions);
        }
    }, [cacheOptions, prevCacheOptions]);
    React.useEffect(function () {
        mounted.current = true;
        return function () {
            mounted.current = false;
        };
    }, []);
    React.useEffect(function () {
        if (propsDefaultOptions === true) {
            loadOptions(propsInputValue !== null && propsInputValue !== void 0 ? propsInputValue : '', function (options) {
                if (!mounted.current) {
                    return;
                }
                setDefaultOptions(options !== null && options !== void 0 ? options : []);
                setIsLoading(!!pendingRequest.current);
            });
        }
    }, 
    /* eslint-disable react-hooks/exhaustive-deps */
    []);
    var options = searchString && loadedSearchString ? asyncOptions : defaultOptions;
    return __assign({ isLoading: isLoading, onSearch: handleOnSearch, options: options !== null && options !== void 0 ? options : [], inputValue: propsInputValue }, comboboxProps);
}
export default useAsync;
//# sourceMappingURL=useAsync.js.map